const module = { name: 'movie/videos/mobile.app', exports: {} }; const exports = module.exports;



import { Fandango_carousel as fdCarousel } from 'require-global';



import { Fandango_debugLog as debugLog } from 'require-core';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { default as headerUI } from 'swug-fdRequire-call:movie/shared/mobile/headerUI';



import { default as videoLinksUI } from 'swug-fdRequire-call:movie/shared/mobile/videoLinksUI';

function run() {
    checkDependencies(module.name, debugLog);
    fdCarousel.init('now-playing-carousel', {
        autoWidth: true,
        lazyLoad: 'sequential',
        padding: { left: '16px', right: '16px' }
    });
    headerUI.attach();
    videoLinksUI.attach();
}
run();
export default module.exports;